module.exports = __webpack_public_path__ + "img/stage1.69fc7d6f.svg";